import { CreateSampleDataInput } from "shared/types/sampleData";
import { axiosClient } from "utilz";

export const createSampleData = async (data: CreateSampleDataInput) => {
  try {
    const url = "v2/sampleData";
    const response = await axiosClient.post(url, data);

    const responseData = response.data;
    if (responseData) {
      return responseData;
    } else {
      throw new Error(responseData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const skipSampleData = async () => {
  try {
    const url = "/skip/sampleData";
    const response = await axiosClient.patch(url);

    const responseData = response.data;
    if (responseData) {
      return responseData;
    } else {
      throw new Error(responseData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const deleteSampleData = async () => {
  try {
    const url = "/servicedesk/all/delete/sampledata";
    const response = await axiosClient.delete(url);

    const responseData = response.data;
    if (responseData) {
      return responseData;
    } else {
      throw new Error(responseData?.message);
    }
  } catch (error) {
    throw error;
  }
};
